module.exports = __webpack_public_path__ + "static/media/LG360W.1f848b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LG360W.jpg
// module id = 1081
// module chunks = 0